import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Skeleton } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useEnvironment, usePerformanceReportBuilderPageStore } from '@diana/core';
import { usePublishDraftLayoutMutation } from '../Mutations/usePublishDraftLayoutMutation';
import { routeUrls } from '../../../app/Routing/RouteUrls';
import { PERFORMANCE_REPORT_BUILDER_PAGE_NS } from '../i18n';
import { usePerformanceReportBuilderPageContext } from '../PerformanceReportBuilderPageContext';

export const PublishButton = () => {
  const { t } = useTranslation(PERFORMANCE_REPORT_BUILDER_PAGE_NS);

  const navigate = useNavigate();
  const environment = useEnvironment();

  const { isLoading, error } = usePerformanceReportBuilderPageContext();

  const isSaving = usePerformanceReportBuilderPageStore((s) => !!s.requests.length);
  const displayName = usePerformanceReportBuilderPageStore((s) => s.layout?.displayName);

  const { mutate: publish, isPending: isPublishing } = usePublishDraftLayoutMutation({
    onSuccess: () => {
      navigate(routeUrls.performance.url({ environment }, null));
    },
  });

  if (isLoading) return <Skeleton variant="rounded" width={75} height={36} />;

  if (!error)
    return (
      <LoadingButton
        data-testid="PublishButton"
        sx={{ p: 1 }}
        variant="contained"
        disabled={isSaving || !displayName}
        onClick={() => publish()}
        loading={isPublishing}
      >
        {t('buttons.publish')}
      </LoadingButton>
    );

  return <Fragment />;
};
